import { AiEndpoint, type OrgDto } from "../../autogen/bff-api";
import { useAppSelector } from "../redux/hooks";

export const orgAllowsFency = (org: Pick<OrgDto, "allowedAiEndpoints">): boolean =>
  org.allowedAiEndpoints?.includes(AiEndpoint.FencyGlobal) ?? false;

export const useAllowsFency = (): boolean =>
  useAppSelector((state) => {
    const authState = state.authState.state;
    return authState?.type === "LoggedInWithOrgContext" && orgAllowsFency(authState.selectedOrg);
  });
